import React from 'react';
import { ScarcityBanner } from '../components/ScarcityBanner';
import { PriceAlert } from '../components/PriceAlert';
import { HeroLP1 } from '../components/HeroLP1';
import { Testimonial } from '../components/Testimonial';
import { ProblemSolution } from '../components/ProblemSolution';
import { ValueStack } from '../components/ValueStack';
import { ModuleBreakdown } from '../components/ModuleBreakdown';
import { Guarantee } from '../components/Guarantee';
import { PricingSection } from '../components/PricingSection';
import { Footer } from '../components/Footer';
import { RecentPurchaseToast } from '../components/RecentPurchaseToast';
export function LandingPageLP3() {
  return <div className="w-full min-h-screen bg-navy font-body text-white" data-id="element-1319">
      <ScarcityBanner data-id="element-1320" />
      <PriceAlert data-id="element-1321" />
      <HeroLP1 data-id="element-1322" />
      <Testimonial data-id="element-1323" />
      <ProblemSolution data-id="element-1324" />
      <ValueStack data-id="element-1325" />
      <ModuleBreakdown data-id="element-1326" />
      <Guarantee data-id="element-1327" />
      <PricingSection data-id="element-1328" />
      <Footer data-id="element-1329" />
      <RecentPurchaseToast data-id="element-1330" />
    </div>;
}